<template lang="pug" src="./navigation-desktop.pug"></template>

<script>
import ModalRequestAppointment from 'components/modal/modal-request-appointment/modal-request-appointment'
import Icon from 'components/icon/icon'

export default {
  props: ['props'],
  computed: {
    content () {
      return this.$store.state.app.navigation
    }
  },
  data () {
    return {
      modal: false
    }
  },
  components: {
    ModalRequestAppointment,
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// navigation-desktop.vue?04ea858d